<template>
  <div class="slider-dots">
    <button
      v-for="index in length"
      :key="index"
      :class="{ active: index - 1 === active }"
      @click="click(index - 1)"
    ></button>
  </div>
</template>

<script>
export default {
  name: 'SliderDots',
  props: {
    length: { type: Number, required: true },
    active: { type: Number, required: true },
  },
  methods: {
    click(index) {
      this.$emit('click', index)
    },
  },
}
</script>

<style lang="scss">
.slider-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: rem(-$spacing * 0.25);
  margin-right: rem(-$spacing * 0.25);

  button {
    position: relative;
    width: rem(20px);
    height: rem(20px);
    margin: 0 rem($spacing * 0.25);
    border: rem(1px) solid transparent;
    border-radius: 50%;
    cursor: pointer;
    background: transparent;
    transition: all 0.3s;

    &::after {
      content: '';
      position: absolute;
      width: rem(12px);
      height: rem(12px);
      background: var(--secondary-color-3);
      top: 50%;
      left: 50%;
      border-radius: 50%;
      transition: all 0.3s;
      transform: translate(-50%, -50%);
    }

    @include on-hover-and-focus {
      &::after {
        background: var(--secondary-color);
      }
    }

    &.active {
      border-color: var(--secondary-color-2);

      &::after {
        background: var(--primary-color);
      }
    }
  }
}
</style>
